import CurrencyCell from 'components/CustomGridCell/CurrencyCell';
import { CustomGridCell } from 'components';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const BillbackTypeCell = (props: GridCustomCellProps) => {
    const value = props.dataItem?.marBillTypeDescription ?? 'Dot Billback';
    return CustomGridCell({ ...props, children: value });
};

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.DotBillback,
    adjustmentTypes: [AdjustmentType.DotBillback],
    title: 'Dot Billbacks',
    dataItemKey: 'rowNumber',
    selectMode: 'multiple',
    selectionGroupField: 'invoiceId',
    selectionGroupTitle: 'Billback Number',
    gridColumns: [
        {
            field: 'invoiceId',
            title: 'Billback Number',
            filterTitle: 'text'
        },
        {
            field: 'marBillTypeDescription',
            title: 'Type',
            cell: BillbackTypeCell,
            filterTitle: 'text'
        },
        {
            field: 'paymentDate',
            title: 'Date',
            format: '{0:MMMM d, yyyy}',
            filterTitle: 'date',
        },
        {
            field: 'adjustmentAmount',
            title: 'Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        }
    ]
}
export default props;
